var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.themeName,on:{"click":_vm.setTheme}},[_vm._v("\n  "+_vm._s(_vm.displayName ? _vm.displayName : _vm.themeName)+"\n  "),_c('br'),_c('img',{staticClass:"gitProf",attrs:{"src":_vm.githubProfile}})])}
var staticRenderFns = []

export { render, staticRenderFns }